import { useEffect, useMemo, useReducer, useState } from 'react';

import { IChipItem } from '../../../../ui/FormChipInput/ChipItem';
import AddNewUsersReducer from './AddNewUsers.reducer';
import { AddNewUsersInitialState } from './AddNewUsers.context';

import { useAPIV2 } from '../../../../../yoello-lib/modules/API2/useAPIv2'
import APIExtensions from '../../../../../yoello-lib/modules/API2/APIDefs';
import { HTTPMethods } from '../../../../../yoello-lib/modules/API/API';

import useSendSnackbar from "../../../../../hooks/useSendSnackbar";
import { Permission } from '../../PermissionChecklist/usePermissionChecklist';
import { ICallAPIFunction } from "../../../../../yoello-lib/modules/API2/types";
import { useSelector } from 'react-redux';
import { IReduxAppState } from '../../../../../reducers';

const useAddNewUsers = (venueId: string, onClose: Function,invitationsListApi:ICallAPIFunction<any>) => {
    const [ state, dispatch ] = useReducer(
        AddNewUsersReducer,
        AddNewUsersInitialState
    );

    const storedLanguage = useSelector(
        (state: IReduxAppState) => state.language.current
      );

    const currentLanguage = useMemo(() => {
        if(storedLanguage.match(/^(US|EN|CA)/i))
            return "EN";
        return storedLanguage.substring(0,2);
    }, [storedLanguage]);

    const { sendSnackbar } = useSendSnackbar();
    
    const [permissions, setPermissions] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const { apiData: apiPermissions, isLoading: isLoadingPermissions }: any = useAPIV2(APIExtensions.permissionSet, {
        query: 'venues',
    });

    const { callAPI: addNewUserRequest }: any = useAPIV2(APIExtensions.venues, {
        selectorKeyParams: { venue_id: venueId },
        dispatcherParams: [venueId],
        onMountDisabled: true,
    });

    const onSubmit = async (data: any) => {
        setIsLoading(true);
        if(data.email_list.length < 1){
            setIsLoading(false);
            sendSnackbar("userManagement.errors.noEmailAddresses", "error");
            return;
        }
        if(data.email_list.some((item: IChipItem) => item.hasError)){
            setIsLoading(false);
            sendSnackbar("userManagement.errors.emailError", "error");
            return;
        }
        if(!data.permissions.some((permission: Permission) => permission.value)){
            setIsLoading(false);
            sendSnackbar("userManagement.errors.noPermissions", "error");
            return;
        }
    
        const formattedNewUsers = data.email_list.map((item: IChipItem) => (
            {
                merchant_email: item.displayText.toLowerCase(),
                language_code: currentLanguage.toUpperCase(),
                permission_sets: data.permissions
                    .filter((permission: any) => permission.value)
                    .map((permission: any) => permission.id)
            }
        ))
        await addNewUserRequest(HTTPMethods.POST, {
            query: `${venueId}/merchants/invitations`,
            body: [...formattedNewUsers],
        }).then(() => {
            sendSnackbar("userManagement.emailInput.success", "success");
            invitationsListApi(HTTPMethods.GET);
            onClose();
            setIsLoading(false);
        }).catch(() => {
            setIsLoading(false);
            sendSnackbar("userManagement.emailInput.failure", "error");
        })
   
    }
    
    useEffect(() => {
        if (apiPermissions?.length) {
          setPermissions(
            apiPermissions.map((permission: Permission) => {
              return {
                ...permission,
                value: false,
              };
            })
          );
        }
      }, [apiPermissions]);

    return {
        onSubmit,
        apiPermissions,
        isLoadingPermissions,
        permissions,
        state,
        dispatch,
        isLoading
    }
}

export default useAddNewUsers;